/* eslint-disable react-hooks/exhaustive-deps */

import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import React, { useState } from 'react';

import Spinner from 'modules/common/spinner.component';
import { deleteHomesaleMortgageInfo, getHomesaleMortgageInfo, postHomesaleMortgageInfo, updateHomesaleMortgageInfo } from 'modules/authorizations/store/actions/homesale.actions';
import MultiRowForm from 'modules/common/multiRowForm.component';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';

const MortgageInfoCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const { homesaleId, homesaleMortgages, isReadOnly, authorizationId, enumerations } = props;

    
  const mortgageTypes = 
    enumerations && enumerations.mortgageTypes && enumerations.mortgageTypes.length > 0
      ? enumerations.mortgageTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

      const formFields = [
    {
      name: 'homesaleMortgageId',
      type: 'hidden'
    },
    {
      name: 'homesaleId',
      type: 'hidden'
    },
    { name: 'mortgageName', type: 'text', label: 'Mortgage Name' },
    { name: 'mortgageTypeId', type: 'dropdown-v2', label: 'Mortgage Type Id', options: mortgageTypes },
    { name: 'mortgageBalance', type: 'money', label: 'Mortgage Balance' },
    { name: 'mortgageRate', type: 'decimal', label: 'Mortgage Rate', inputProps: { step: '0.01' } },
  ];

  const formLabel = 'Mortgages';
  const addRowLabel = 'Add Mortgage';
  const header = { title: 'Mortgages', iconPath: ['fas', 'file-invoice-dollar'] };

  const createNewRowFunc = () => {
    return {
      homesaleMortgageId: 0,
      homesaleId: homesaleId,
      mortgageName: '',
      mortgageTypeId: '',
      mortgageBalance: 0,
      mortgageRate: 0
    };
  };

  const saveForm = async formValues => {
    setIsLoading(true);

    formValues = formValues ?? [];

    const deletedMortgages = homesaleMortgages.filter(
      mortgage => !formValues.some(formValue => formValue.homesaleMortgageId === mortgage.homesaleMortgageId)
    );

    const newMortgages = formValues.filter(formValue => formValue.homesaleMortgageId === 0);

    const updatedMortgages = formValues.filter(
      formValue =>
        formValue.homesaleMortgageId !== 0
    );

    try {
      for (const mortgage of deletedMortgages) {
        await props.deleteHomesaleMortgageInfo(authorizationId, mortgage.homesaleMortgageId);
      }

      for (const mortgage of newMortgages) {
        mortgage.mortgageBalance = mortgage.mortgageBalance ? parseFloat(mortgage.mortgageBalance) : 0;
        mortgage.mortgageRate = mortgage.mortgageRate ? parseFloat(mortgage.mortgageRate) : 0;
      }

      let newValues = Array.isArray(newMortgages) ? newMortgages : [newMortgages];
      await props.postHomesaleMortgageInfo(authorizationId, newValues);

      for (const mortgage of updatedMortgages) {
        mortgage.mortgageBalance = mortgage.mortgageBalance ? parseFloat(mortgage.mortgageBalance) : 0;
        mortgage.mortgageRate = mortgage.mortgageRate ? parseFloat(mortgage.mortgageRate) : 0;
      }

      let updatedValues = Array.isArray(updatedMortgages) ? updatedMortgages : [updatedMortgages];
      await props.updateHomesaleMortgageInfo(authorizationId, updatedValues);


    } catch (error) {
      console.error('Error saving form:', error);
      props.showToast('Failed to update Mortgages, please try again later', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } finally {

      await props.getHomesaleMortgageInfo(homesaleId);
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Spinner />}
      {!isLoading && (
        <MultiRowForm
          formValues={homesaleMortgages.map(item => ({ ...item })) || []}
          saveFunction={saveForm}
          formFields={formFields}
          createNewRowFunc={createNewRowFunc}
          formLabel={formLabel}
          addRowLabel={addRowLabel}
          isDisabled={isReadOnly}
          header={header}
        />
      )}
    </>
  );
};

export default compose(
  connect(null, {
    showToast,
    getHomesaleMortgageInfo,
    postHomesaleMortgageInfo,
    updateHomesaleMortgageInfo,
    deleteHomesaleMortgageInfo
  })
)(MortgageInfoCard);
